import { request } from './base';

export const google = () => {
  return request({
    method: 'get',
    url: 'account/google-login',
  });
};
